// REST 调用层（HMAC over X-Auth-Ear header）。
import { signRequest } from "../crypto/hmac";
import { tokenStore } from "../storage/tokens";

export interface AgentStatus {
  id: string;
  alias: string;
  online: boolean;
  uptime_sec: number;
  version: string;
  os?: string;
  hostname?: string;
}

export interface AgentsResp {
  agents: AgentStatus[];
  count: number;
  server_ts: number;
}

export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    message: string
  ) {
    super(message);
  }
}

async function authedFetch(method: string, path: string, body?: unknown): Promise<Response> {
  const ident = await tokenStore.getIdentity();
  if (!ident) throw new ApiError(401, "no_identity", "未配对，请先在 dev 配对页录入 device_id+token");
  const bodyStr = body == null ? null : JSON.stringify(body);

  const { authHeaderValue } = await signRequest(
    ident.device_id,
    ident.token,
    method,
    path,
    bodyStr
  );

  const headers: Record<string, string> = { "X-Auth-Ear": authHeaderValue };
  if (bodyStr != null) headers["Content-Type"] = "application/json";

  const url = new URL(path, ident.gw_url).toString();
  const resp = await fetch(url, { method, headers, body: bodyStr ?? undefined });
  if (!resp.ok) {
    let code = "http_error";
    let msg = `HTTP ${resp.status}`;
    try {
      const j = await resp.json();
      code = j.code ?? code;
      msg = j.error ?? j.message ?? msg;
    } catch {
      /* not json */
    }
    throw new ApiError(resp.status, code, msg);
  }
  return resp;
}

export const api = {
  async listAgents(): Promise<AgentsResp> {
    const r = await authedFetch("GET", "/api/agents");
    return r.json();
  },

  async ping(): Promise<{ pong: boolean; device_id: string; server_ts: number }> {
    const r = await authedFetch("GET", "/api/ping");
    return r.json();
  }
};
